const sidebar = {
    leftWidth: 232,
    rightWidth: 350,
    canvasFirstRightWidth: 295,
};

export { sidebar };
